import "./btn.css";

const BtnPost = (props) => {
  const { btnLink, btnType, widthBtn, customCss, text, svgIcon, target } = props;

  return (
    <a
      href={btnLink}
      target= {target}
      class={`block-button ${widthBtn} ${customCss}`}
      alt={`Redirección`}
    >
      <button class={`block-button__btn ${widthBtn} ${btnType}`}>
        <span class="block-button__text">{text}</span>
        <div class="block-button__icon">
         {
          svgIcon && (
            <img src={svgIcon} alt="Icono de redirección de noticia"/>
          )
         }
        </div>
      </button>
    </a>
  );
};

export default BtnPost;
